import styled from 'styled-components'

export const ContentColumnsContainer = styled.div<{
  $moduleTheme?: string
  $bottomPadding?: string
  $topPadding?: string
  $textAlignment?: string
  $orangeDivider?: boolean
  $pageType?: string
  $useCase?: string
}>`
  ${({
    theme,
    $moduleTheme,
    $topPadding,
    $bottomPadding,
    $textAlignment,
    $orangeDivider,
    $pageType,
    $useCase,
  }: any) => {
    let themeStyles,
      topPaddingStyles,
      bottomPaddingStyles,
      orangeLineStyles,
      richTextStyles,
      pageTypeStyles

    if ($pageType === 'aboutRPA') {
      pageTypeStyles = `
        .ContentColumns__Item-Heading {
          font-size: 36px;
          line-height: 44px;
        }
      `
    }

    if ($moduleTheme === 'Dark') {
      themeStyles = `
        // Dark Styles
        background-color: ${theme.webMktNewPalette.deepBlue[70]};

        .ContentColumns__Item-Heading,.ContentColumns__Item-SubHeading,.ContentColumns__Item-List li,p {
          color: ${theme.webMktNewPalette.white};
        }

        .ContentColumns__Item-Body {
          a {
            color: #38c6f4;
          }
        }
      `
    }

    if ($moduleTheme === 'Light') {
      themeStyles = `
        // Light Styles
        background-color: ${theme.webMktNewPalette.background.light.default};
        
        .ContentColumns__Item-Heading, .ContentColumns__Item-SubHeading, .ContentColumns__Item-List li, p {
          color: ${theme.webMktNewPalette.black};
        }
      `
    }

    if ($moduleTheme === 'Gray') {
      themeStyles = `
        // Gray Styles
        background-color: ${theme.webMktNewPalette.deepBlue[10]};
        
        .ContentColumns__Item-Heading, .ContentColumns__Item-SubHeading, .ContentColumns__Item-List li, p {
          color: ${theme.webMktNewPalette.black};
        }
      `
    }

    if ($topPadding === 'Yes') {
      topPaddingStyles = `
        padding-top: 108px;
      `
    } else if ($topPadding === 'Large') {
      topPaddingStyles = `
        padding-top: 68px;
      `
    } else if ($topPadding === 'Small') {
      topPaddingStyles = `
        padding-top: 36px;
      `
    } else {
      topPaddingStyles = `
        padding-top: 0;
      `
    }

    if ($bottomPadding === 'Large') {
      bottomPaddingStyles = `
        padding-bottom: 56px;
      `
    } else {
      bottomPaddingStyles = `
        padding-bottom: 36px;
      `
    }

    if ($textAlignment === 'center') {
      orangeLineStyles = `
        left: 50%;
        transform: translateX(-50%);
      `
      richTextStyles = `
        margin: 0 auto 24px auto;
        width: fit-content;
      `
    }

    if ($textAlignment === 'right') {
      orangeLineStyles = `
        right: 0;
      `
      richTextStyles = `
        margin: 0 0 24px auto;
        width: fit-content;
      `
    }

    if ($textAlignment === 'left' || $textAlignment === 'justify') {
      orangeLineStyles = `
        left: 0;
      `
    }

    return `
      ${themeStyles}
      ${topPaddingStyles}
      ${bottomPaddingStyles}
      width: 100%;

      ${pageTypeStyles}

      .ContentColumns__Grid-Item {
        text-align: ${$textAlignment};

        .ContentColumns__Item {
          &:before {
            ${$orangeDivider ? orangeLineStyles : 'content: none;'}
          }
        }

        .ContentColumns__Item-List {
          ${
            richTextStyles &&
            `
              ul, ol {
                ${richTextStyles}
              }
            `
          }
        }
      }
    `
  }}

  .ContentColumns__Container {
    // Styles targeted only for page AboutRPA and Flex template
    ${({ $pageType, $useCase }) => {
      if (($pageType === 'aboutRPA' || $pageType === 'flex') && $useCase === 'Full width') {
        return `
          margin: ${$pageType === 'aboutRPA' ? '0 auto 0 0' : '0 auto'};
          max-width: 1374px;
        `
      }
    }}
  }

  .ContentColumns__Grid-Item {
    padding: 12px;
    margin-bottom: 64px;

    &.MuiGrid-item {
      // Styles targeted only for page AboutRPA and Flex template
      ${({ $pageType, $useCase }) =>
        ($pageType === 'aboutRPA' || $pageType === 'flex') &&
        $useCase === 'Full width' &&
        `padding: 8px 16px 8px 8px;`}

      ${({ theme }) => theme.breakpoints.down('sm')} {
        padding: 8px;
      }
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin-bottom: 48px;
    }
  }

  .ContentColumns__Upper-Heading {
    text-align: center;
    margin-bottom: 50px;
    padding: 32px 0 0;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      font-size: 28px;
      letter-spacing: 0px;
      line-height: 36px;
    }
  }

  .ContentColumns__Item {
    position: relative;
    padding-top: 28px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin-bottom: 24px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 100%;
      margin-bottom: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      width: 80px;
      height: 4px;
      background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
    }
  }

  .ContentColumns__Item-Heading {
    font-size: 28px;
    font-weight: 600;
    letter-spacing: -2px;
    line-height: 32px;
    margin: 0;

    // Styles targeted only for page AboutRPA and Flex template
    ${({ $pageType, $useCase }) =>
      ($pageType === 'aboutRPA' || $pageType === 'flex') &&
      $useCase === 'Full width' &&
      `font-size: 36px;
        line-height: 44px;`}

    ${({ theme, $orangeDivider }) =>
      $orangeDivider
        ? `
        padding-top: 0;

        ${theme.breakpoints.down('sm')} {
          padding-top: 0;
        }

        ${theme.breakpoints.down('xs')} {
          padding-top: 0;
        }
      `
        : ''}

    ${({ theme }) => theme.breakpoints.down('xs')} {
      letter-spacing: 0;
    }
  }

  .ContentColumns__Item-Image {
    margin-bottom: 8px;
    img {
      max-width: 96px;
      max-height: 96px;
    }
  }

  .ContentColumns__Item-SubHeading {
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0px;
    margin-top: 24px;
    line-height: 24px;
  }

  .CTA {
    margin-top: 24px;
  }

  .ContentColumns__Item-List {
    margin-top: 24px;
    // Styles targeted only for page AboutRPA and Flex template
    ${({ $pageType, $useCase }) =>
      ($pageType === 'aboutRPA' || $pageType === 'flex') &&
      $useCase === 'Full width' &&
      `margin-top: 16px; word-break: break-word;`}

    > *:last-child {
      margin-bottom: 0;
    }

    p,
    ul,
    ol {
      margin-bottom: 24px;
    }

    ul {
      list-style: disc;
      padding: 0 0 0 24px;

      li {
        padding-left: 8px;

        &:not(:first-of-type) {
          margin: 8px 0 0 0;
        }
      }
    }

    ol {
      padding: 0 0 0 24px;
      margin: 24px 0 0 0;

      li {
        padding-left: 8px;

        &:not(:first-of-type) {
          margin: 8px 0 0 0;
        }
      }
    }

    li,
    p {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      line-height: 24px;

      // Styles targeted only for page AboutRPA and Flex template
      ${({ $pageType, $useCase }) =>
        ($pageType === 'aboutRPA' || $pageType === 'flex') &&
        $useCase === 'Full width' &&
        `font-size: 20px;
        line-height: 32px;
        letter-spacing: -0.5px`}
    }

    li {
      p {
        margin: 0;
      }
    }
  }
`
